import React, { Component, PropTypes } from "react";
import { Icon } from "../containers/LayoutContainer/Header/Menu/LeftMenu/LeftMenu.style";
import DashboardIcon from "@material-ui/icons/Dashboard";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import PermContactCalendarIcon from "@material-ui/icons/PermContactCalendar";
import RestorePageIcon from "@material-ui/icons/RestorePage";
import StoreIcon from '@material-ui/icons/Store';
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';
import {
  CloudUpload,
  Image,
  Notifications,
  SportsMotorsports,
  Settings,
  LocationOn,
  ViewCarousel,
  Category,
  DeviceHub,
  ShoppingCart,
  LocalMallSharp,
  LocalOffer,
  ShoppingBasket,
  Widgets,
  Smartphone,
  BarChart,
  Payment,
  Build,
  ListAlt,
  LocalMall,
  CalendarToday,
} from "@material-ui/icons";
import DesktopWindowsIcon from "@material-ui/icons/DesktopWindows";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
// import CampaignIcon from "../components/Image/campaign_FILL0_wght400_GRAD0_opsz48 (1).svg"
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import { AiFillSound } from "react-icons/ai";
import { RiCoupon3Fill } from "react-icons/ri";
import { BiBookContent } from "react-icons/bi";
import SettingsApplicationsIcon from "@material-ui/icons/SettingsApplications";
import { FaFileUpload } from "react-icons/fa";
import { GiCloudUpload } from "react-icons/gi";
import { TiUpload } from "react-icons/ti";
import { RiFileTransferFill } from "react-icons/ri";
import { ImTruck } from "react-icons/im";
import { IoIosImage } from "react-icons/io";
import { MdNotificationsActive } from "react-icons/md";
import { FaUsers } from "react-icons/fa";
import { FaShoppingBasket } from "react-icons/fa";
import DescriptionIcon from '@material-ui/icons/Description';
import PersonIcon from '@material-ui/icons/Person';
import { RiListSettingsLine } from "react-icons/ri";
import DateRangeIcon from '@material-ui/icons/DateRange';
import { RiListSettingsFill } from "react-icons/ri";
import { AiOutlineFileAdd } from "react-icons/ai";
import FastfoodIcon from '@material-ui/icons/Fastfood';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import PlaceIcon from '@material-ui/icons/Place';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';

const SidebarData = [
  {
    name: "Analytics",
    icon: <BarChart />,
    link: "/admin/analytics",
    sub: [],
  },
  {
    name: "Orders",
    icon: <ShoppingCart />,
    link: "",
    sub: [
      {
        name: "Order Management",
        icon: <ShoppingBasketIcon />,
        link: "/admin/orders",
      },
      {
        name: "Order Map",
        icon: <LocationOn />,
        link: "/admin/order_map",
      },
      {
        name: "Customers",
        icon: <FaUsers style={{ fontSize: "25px" }}/>,
        link: "/admin/customers",
      },
      {
        name: "Basket",
        icon: <FaShoppingBasket style={{ fontSize: "25px" }}/>,
        link: "/admin/baskets",
      },
      {
        name: "Payment Link",
        icon: <Payment />,
        link: "/admin/generate-payment-link",
      },
    ],
  },
  {
    name: "Marketing",
    icon: <AiFillSound style={{ fontSize: "25px" }} />,
    link: "",
    sub: [
      {
        name: "Notification Center",
        icon: <MdNotificationsActive style={{ fontSize: "25px" }}/>,
        link: "/admin/notification-center",
      },
      {
        name: "Promotion Campaigns",
        icon: <LocalOfferIcon />,
        link: "/admin/promotion-campaigns",
      },
      {
        name: "Coupon",
        icon: <RiCoupon3Fill style={{ fontSize: "25px" }} />,
        link: "/admin/coupon",
      },
	    {
		    name: "Delipoint Promotions",
		    icon: <CalendarToday/>,
		    link: "/admin/delipoint-promotions",
	    },
    ],
  },
  {
    name: "Content",
    icon: <BiBookContent style={{ fontSize: "25px" }} />,
    link: "",
    sub: [
      {
        name: "Slider Banner",
        icon: <ViewCarousel />,
        link: "/admin/slide-banner",
      },
      {
        name: "HomePage Settings",
        icon: <Settings />,
        link: "/admin/homepagesetting",
      },
      {
        name: "Store Logo",
        icon: <Image />,
        link: "/admin/store-logo",
      },
      {
        name: "Banner Update",
        icon: <IoIosImage style={{ fontSize: "25px" }}/>,
        link: "/admin/banner_update",
      },
      {
        name:"Popular Search",
        icon: <DescriptionIcon />,
        link: "/admin/recent-search-popular"
      },
      {
        name: "Partner Page",
        icon: <AiOutlineFileAdd style={{ fontSize: "25px" }}/>,
        link: "/admin/partner-page/list"
      },
      {
          name: "Landing Page",
          icon: <AiOutlineFileAdd style={{ fontSize: "25px" }}/>,
          link: "/admin/landing-page/list"
      },
	    {
		    name: "Selections",
		    icon: <AiOutlineFileAdd style={{ fontSize: "25px" }}/>,
		    link: "/admin/selections"
	    },
    ],
  },
  {
    name: "Products",
    icon: <ShoppingBasket />,
    link: "/admin/products",
    sub: [],
  },
  {
    name: "Product navigation",
    icon: <ShoppingBasket />,
    link: "",
    sub: [
      {
        name: "Categories",
        icon: <Category />,
        link: "/admin/categories",
      },
      {
        name: "SubCategories",
        icon: <DeviceHub />,
        link: "/admin/subCategories",
      },
      {
        name: "Brand",
        icon: <LocalMallSharp />,
        link: "/admin/brands",
      },
      {
        name: "Menu",
        icon: <Widgets />,
        link: "/admin/menu",
      },
	    {
		    name: "DietaryPreferences",
		    icon: <FastfoodIcon/>,
		    link: "/admin/dietary_preferences",
	    },
    ],
  },
  {
    name: "Supplier",
    icon: <ImTruck style={{ fontSize: "25px" }} />,
    link: "",
    sub: [
      {
        name: "Suppliers",
        icon: <LocalShippingIcon />,
        link: "/admin/suppliers",
      },
      {
        name: "Assign Supplier Picker",
        icon: <SportsMotorsports />,
        link: "/admin/assign-picker",
        sub: [],
      },
      {
        name: "Warehouse",
        icon: <StoreIcon />,
        link: "/admin/warehouses",
        sub: [],
      },
      {
        name: "Supplier Product",
        icon: <IndeterminateCheckBoxIcon />,
        link: "/admin/supplierProducts",
        sub: [],
      },
      {
        name: "Stock Management",
        icon: <LocalMall />,
        link: "/admin/stocks",
        sub: [],
      },
      {
        name: "Product Weights (WMS)",
        icon: <LocalMall />,
        link: "/admin/wms-weights",
        sub: [],
      },
    ],
  },
  {
    name: "Bulk actions",
    icon: <GiCloudUpload style={{ fontSize: "25px" }} />,
    link: "",
    sub: [
      {
        name: "Bulk Extract",
        icon: <RiFileTransferFill style={{ fontSize: "25px" }} />,
        link: "/admin/bulkExtract",
      },
      {
        name: "Bulk Uploads",
        icon: <DesktopWindowsIcon />,
        link: "/admin/bulkUploads",
      },
      {
        name: "Bulk Images Upload",
        icon: <TiUpload style={{ fontSize: "25px" }} />,
        link: "/admin/bulkImageUploads",
      },
    ],
  },
  {
    name: "Settings",
    icon: <SettingsApplicationsIcon />,
    link: "",
    sub: [
      {
        name: "Settings",
        icon: <Settings />,
        link: "/admin/deli_express_settings",
        sub: [],
      },
      {
        name: "Users",
        icon: <PersonIcon />,
        link: "/admin/users",
        sub: [],
        permission: { head: "Users", key: "users_view" },
      },
      {
        name: "Driver",
        icon: <SportsMotorsports />,
        link: "/admin/drivers",
        sub: [],
      },
      {
        name: "Maintenance Mode",
        icon: <Build />,
        link: "/admin/maintenance/mode",
        sub: [],
      },
      {
        name: "Search Configuration",
        icon: <Settings />,
        link: "/admin/search-configuration",
        sub: [],
      },
      {
        name: "App Versions",
        icon: <Smartphone />,
        link: "/admin/app-versions",
        sub: [],
      },
      {
        name: "StoreOngoing Slot",
        icon: <DateRangeIcon />,
        link: "/admin/store_ongoing_slot",
        sub: [],
      },
      {
        name: "Store Slot Settings",
        icon: <RiListSettingsFill style={{ fontSize: "25px" }}/>,
        link: "/admin/store_slot_settings_ids",
        sub: [],
      },
	    {
		    name: "Delipoint Tiers",
		    icon: <MonetizationOnIcon/>,
		    link: "/admin/delipoint-tiers",
	    },
	    {
		    name: "Delipoint Settings",
		    icon: <Settings/>,
		    link: "/admin/delipoint-settings",
	    },
	    {
		    name: "Delivery Companies",
		    icon: <LocalShippingIcon/>,
		    link: "/admin/delivery-companies",
	    },
	    {
		    name: "Pickup Points",
		    icon: <PlaceIcon/>,
		    link: "/admin/pickup-points",
	    },
	    {
		    name: "Delivery Rates",
		    icon: <LocalAtmIcon/>,
		    link: "/admin/delivery-rates",
	    },
    ],
  },
];

export default SidebarData;
